import React from 'react'
import GetRequest from '../Services/APIRequest'
 

const FarmerAddedLastWeekBox = () => {
  
  const distID = localStorage.getItem('distributorId');
  const boostID = localStorage.getItem('companyIdBooster');
  const parisID = localStorage.getItem('companyIdParis'); 

  const { data } = GetRequest(`/Farmer/GetNumberOfNewlyAddedFarmersInDistributorsArea/${distID}`);
  if(data.result !== '') {
  return (
    <div className="col-lg-3 col-6">
        <div className="small-box scol1">
            <div className="inner">
                <h4>{data.result}</h4> 
                <p>Farmers Added in last week</p>
            </div>
            <div className="icon">
                <i className="fa fa-shopping-cart"></i>

            </div>
            
        </div>
    </div>

  )
} else {
  return (
    <> </>
   )
}

}

export default FarmerAddedLastWeekBox